module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mw-d0647be6ce1ff498b63dce7660bf21c3.svg";